export default "__VITE_ASSET__wL1jxDr3__"